import { render, staticRenderFns } from "./BinTitle.vue?vue&type=template&id=30385c20&scoped=true&"
import script from "./BinTitle.vue?vue&type=script&lang=js&"
export * from "./BinTitle.vue?vue&type=script&lang=js&"
import style0 from "./BinTitle.vue?vue&type=style&index=0&id=30385c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30385c20",
  null
  
)

export default component.exports